module.exports = __webpack_public_path__ + "static/logo-ebfcaeb42cb571a048ee5deea27fa07a.png";